import { Checkbox as UICheckbox } from "@webmotors/eleanor-ui";

export type LabelSides = "left" | "right";
export type Tokens = "primary" | "secondary";
export type Variants = "default" | "indeterminate";
export type Spacings = "small" | "medium" | "large";

export interface CheckboxProps
  extends Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    "checked" | "className" | "disabled"
  > {
  checked?: boolean;
  className?: string;
  dataQA?: string;
  disabled?: boolean;
  label?: React.ReactNode;
  labelSide?: LabelSides;
  token?: Tokens;
  variant?: Variants;
  thumbnail?: boolean;
  thumbnailSrc?: string;
  customThumbnail?: React.ReactNode;
}

export function Checkbox({
  checked = false,
  className,
  dataQA,
  disabled = false,
  label,
  labelSide = "right",
  token = "primary",
  variant = "default",
  ...props
}: Readonly<CheckboxProps>) {
  return (
    <UICheckbox
      checked={checked}
      className={className}
      dataQA={dataQA}
      disabled={disabled}
      label={label}
      labelSide={labelSide}
      token={token}
      variant={variant}
      {...props}
    />
  );
}
